const messages = {
  name: 'Transaccion de Credito |||| Transacciones de Credito',
  fields: {
    account: 'Cuenta',
    costCenterName: 'Centro de Coste',
    transactionType: 'Tipo',
    amount: 'Importe',
    balanceAfter: 'Saldo Despues',
    createdAt: 'Creado El',
    createdByUserName: 'Creado Por',
  },
  empty: 'No hay transacciones de credito',
  actions: {
    exportCsv: 'CSV',
    exportPdf: 'PDF',
  },
  filters: {
    account: 'Cuenta',
    costCenterName: 'Centro de Coste',
    transactionType: 'Tipo de Transaccion',
  },
  search: {
    placeholder: 'Buscar Transacciones de Credito',
  },
};

export default messages;
